var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"sidebar"},[_c('v-sidebar')],1),_c('div',{staticClass:"content-box"},[_c('Layout')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }